const PEOPLE = [
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20stylish%20young%20man%20seen%20from%20behind%20standing%20in%20a%20press%20room%2C%20warm%20amber%20and%20crimson%20lighting%2C%20cinematic%20film%20grain%2C%20moody%20atmosphere%2C%20celebrity%20magazine%20portrait%20aesthetic&width=640&height=820&seq=people-figure-01&orientation=portrait",
    name: "某某·预告明星",
    role: "音乐人 · 讨论热度榜首",
    desc: "站内查找该人物专题的次数本周激增，多条旧访谈被重新扒出比对。",
    meta: "4.6 万关注",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20fashionable%20woman%20in%20high%20heel%20shoes%20walking%20toward%20a%20bright%20spotlight%20on%20stage%20seen%20from%20the%20back%2C%20warm%20gold%20and%20crimson%20backlight%2C%20cinematic%20film%20grain%2C%20elegant%20dramatic%20magazine%20editorial%20look&width=640&height=820&seq=people-figure-02&orientation=portrait",
    name: "卷·旧番考古",
    role: "演员 · 专题连载中",
    desc: "人物专题持续更新，把她过去十年作品按时间线完整归档，供网友对照吃瓜。",
    meta: "3.1 万关注",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20mysterious%20figure%20in%20a%20trench%20coat%20silhouetted%20against%20city%20neon%20lights%20at%20night%20seen%20from%20behind%2C%20warm%20amber%20and%20deep%20red%20glow%2C%20cinematic%20film%20grain%2C%20intrigue%20and%20secrecy%2C%20documentary%20gossip%20investigation%20mood&width=640&height=820&seq=people-figure-03&orientation=portrait",
    name: "匿名爆料人",
    role: "线索人 · 事件关联者",
    desc: "一个不断浮出水面又迅速隐身的名字，站内追踪锁定多条线索交叉点。",
    meta: "1.8 万关注",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photograph%20of%20a%20young%20group%20of%20friends%20at%20a%20vibrant%20outdoor%20concert%20seen%20from%20the%20back%2C%20warm%20sunset%20amber%20and%20crimson%20stage%20light%2C%20cinematic%20film%20grain%2C%20lively%20energetic%20magazine%20storytelling%20moment&width=640&height=820&seq=people-figure-04&orientation=portrait",
    name: "新晋·话题人物",
    role: "新锐 · 正被深扒",
    desc: "出道即热搜，人物专题收录速度跟不上网友的考古速度，讨论仍在继续。",
    meta: "2.3 万关注",
  },
];

export default function PeopleSection() {
  return (
    <section id="people" className="border-y border-[#e5ded2] bg-white/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-2 text-sm font-semibold text-red-700">
              <span className="h-px w-8 bg-red-700"></span>
              人物专题 · 一人一档案
            </div>
            <h2 className="font-serif-sc mt-3 text-balance text-2xl font-black text-stone-900 md:text-3xl">
              有人被捧起，也有人正在被扒起底
            </h2>
          </div>
          <a href="#search" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-stone-500 hover:text-red-700">
            按人物站内查找
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PEOPLE.map((p) => (
            <article key={p.name} className="paper-card group overflow-hidden rounded-lg">
              <div className="relative overflow-hidden">
                <img
                  src={p.image}
                  alt={`${p.name} 网曝网人物专题档案`}
                  title={`${p.name} 网曝网人物专题`}
                  className="h-72 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-sm bg-[#f7f3eb]/92 px-2 py-0.5 text-[11px] font-semibold text-stone-700">
                  {p.role.split("·")[1] || "人物专题"}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-serif-sc text-base font-bold text-stone-900">{p.name}</h3>
                <p className="mt-0.5 text-xs text-red-700">{p.role}</p>
                <p className="mt-2 text-xs leading-5 text-stone-500">{p.desc}</p>
                <div className="mt-3 flex items-center justify-between border-t border-stone-100 pt-3">
                  <span className="flex items-center gap-1 text-xs text-stone-400">
                    <i className="ri-user-follow-line w-4 h-4 flex items-center justify-center"></i>
                    {p.meta}
                  </span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-red-700 px-3 py-1.5 text-xs font-semibold text-[#f7f3eb] transition-colors hover:bg-red-800"
                  >
                    <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                    关注
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}